module.exports = __webpack_public_path__ + "img/facebook-active.6aa87e42.svg";